export default {
    // Action perf for FindPeople operation. querySTring == null (owa_1 == false) should be tossed.
    MentionsFindPeople: {
        name: 'MentionsFindPeople',
    },
};
